import gql from 'graphql-tag';

const UPDATE_HARDWARE = gql`
  mutation Mutation($deviceSerialNo: String!, $hardwareVersion: Int!) {
    updateHardware(deviceSerialNo: $deviceSerialNo, hardwareVersion: $hardwareVersion) {
      code
    }
  }
`;

export default UPDATE_HARDWARE;
